import React,{useState}from 'react'
import Top from './Top'
import VFooter from './VFooter'
import { Card, Accordion } from './ui';

export default function Faqs() {
    const [activeAccordion, setActiveAccordion] = useState(null);

    const toggleAccordion = (index) => {
      setActiveAccordion(activeAccordion === index ? null : index);
    };
  
    const faqs = [
      {
        question: "1. What is Vasstr?",
        answer: "Vasstr is an online platform connecting fashion designers with users, allowing designers to showcase their work and receive orders."
      },
      {
        question: "2. How do I register as a designer on Vasstr?",
        answer: "Before registering as a designer, you must review and sign the agreement provided. By signing the agreement, you acknowledge that you understand and agree to these terms and any future updates."
      },
      {
        question: "3. Can I showcase all my designs on Vasstr?",
        answer: "Yes! You can upload and display your entire portfolio on your designer profile."
      },
      {
        question: "4. How do I receive orders from users?",
        answer: "When a user places an order or creates a custom bid that matches your designs, you will receive a notification with the order details."
      },
      {
        question: "5. What if a user wants to customize my design?",
        answer: "Users can request customizations like fabric and color. You can review their requests and confirm the changes before proceeding."
      },
      {
        question: "6. How do I get paid for my orders?",
        answer: "Payments are directly sent to your bank account after the user receives their product, with a 3% fee deducted from the total order price."
      },
      {
        question: "7. Will my designs be safe on Vasstr?",
        answer: "Yes, your designs are securely stored on our platform and will not be shared without your permission."
      },
      {
        question: "8. Is there a fee for using the Vasstr platform?",
        answer: "There are no upfront fees for designers. You only pay a 3% commission after a successful sale."
      },
      {
        question: "9. How can I update my profile or portfolio?",
        answer: "You can log in to your designer account and make changes to your profile and portfolio at any time."
      },
      {
        question: "10. What happens if I upload unwanted photos with my products?",
        answer: "If you upload inappropriate or unwanted photos, you will receive a warning. Repeated violations may result in account deactivation."
      },
      {
        question: "11. What should I do if I have a problem with an order?",
        answer: "If you encounter any issues, please contact our support team for assistance."
      }
    ];
  return (
    <div>
        <Top/>
       <main className="pt-16">
        <section className="bg-[#f4ece5] py-16 px-4">
          <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md">
            <h2 className="text-3xl font-bold text-center mb-8">FAQs</h2>
            
            <div className="space-y-4 max-w-2xl mx-auto">
              {faqs.map((faq, index) => (
                <div key={index} className="border border-gray-300 rounded-lg overflow-hidden">
                  <button 
                    className={`w-full flex justify-between items-center p-4 text-left bg-[#f7f5f2] hover:bg-[#f0ede8] transition-colors ${activeAccordion === index ? 'font-semibold' : ''}`}
                    onClick={() => toggleAccordion(index)}
                  >
                    <span>{faq.question}</span>
                    <span className={`text-[#d25614] text-xl ${activeAccordion === index ? 'transform rotate-45' : ''}`}>
                      {activeAccordion === index ? '-' : '+'}
                    </span>
                  </button>
                  <div 
                    className={`transition-all duration-300 ease-in-out overflow-hidden ${activeAccordion === index ? 'max-h-40' : 'max-h-0'}`}
                  >
                    <div className="p-4">
                      <p className="text-gray-700">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <VFooter/>
    </div>
  )
}
